import React, { useState } from "react";
import "../styles/app.css";
import { useSelector } from "react-redux";
import Header from "./components/Header.jsx";
import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";
import Carousel from "./components/Carousel.jsx";
import Container from "@mui/material/Container";

const API_BASE_URL = "https://onpr.bi/onpr_api/public/api";

const AppLayout = ({
  children,
  isShowSlider = true,
  contentContainerSx = {},
  hideFooter = false,
  hideNavbar = false,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const { data: allArticles } = useSelector((state) => ({
    data: state.apiData?.data?.actualites,
  }));

  const handleSearch = async (query) => {
    setIsSearching(true);
    try {
      const response = await fetch(`${API_BASE_URL}/articles`);
      const data = await response.json();
      const filtered = data.data.filter(
        (article) =>
          article.title.toLowerCase().includes(query.toLowerCase()) ||
          article.title_en.toLowerCase().includes(query.toLowerCase()) ||
          article.body_en.toLowerCase().includes(query.toLowerCase()) ||
          article.body.toLowerCase().includes(query.toLowerCase()),
      );
      setSearchResults(filtered.slice(0, 5));
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  return (
    <div>
      <>
        <Header
          onSearch={handleSearch}
          searchResults={searchResults}
          isSearching={isSearching}
        />
        {!hideNavbar && <Navbar />}
        {isShowSlider && <Carousel />}

        <Container maxWidth="lg" sx={{ py: 4, ...contentContainerSx }}>
          {children}
        </Container>

        {!hideFooter && <Footer />}
      </>
    </div>
  );
};

export default AppLayout;
